import { useMemo } from 'react';

import { useBreakpointsContext } from '@air/provider-media-query';

import BoardCrumbs from '~/components/Workspace/BoardHeader/BoardCrumbs';
import { type BoardAncestorsDropdownProps } from '~/components/Workspace/BoardHeader/BoardCrumbs/BoardAncestorsDropdown';
import { ShortBoardCrumbs } from '~/components/Workspace/BoardHeader/BoardCrumbs/ShortBoardCrumbs';

type RootBoardStickyHeaderProps = {
  title: string;
} & BoardAncestorsDropdownProps;

export const ViewControlsBoardHeader = ({ title, ancestors = [], onBoardClick }: RootBoardStickyHeaderProps) => {
  const { isAboveXLScreen } = useBreakpointsContext();

  const ancestorsView = useMemo(() => {
    if (isAboveXLScreen) {
      if (!ancestors.length) {
        return <div className="truncate font-medium ads:text-secondary text-12 text-gray-11">{title}</div>;
      } else {
        return <BoardCrumbs ancestors={ancestors} title={title} onBoardClick={onBoardClick} />;
      }
    }

    return <ShortBoardCrumbs ancestors={ancestors} title={title} onBoardClick={onBoardClick} />;
  }, [ancestors, isAboveXLScreen, onBoardClick, title]);

  return <div className="flex">{ancestorsView}</div>;
};
